import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const questions = [
  {
    step: '01',
    title: 'Who is at risk?',
    description: 'Surface customers showing meaningful churn risk.',
    color: '#00b9ff',
  },
  {
    step: '02',
    title: 'Why?',
    description: "See what changed and what's likely driving it.",
    color: '#ffbe00',
  },
  {
    step: '03',
    title: 'What should we do next?',
    description: 'Get a recommended action your team can take.',
    color: '#00d688',
  },
];

export default function ProductFlowSection() {
  return (
    <section className="py-24 px-6 border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-14">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            Separate meaningful churn risk from normal customer variation.
          </h2>
          <div className="space-y-5 landing-prose">
            <p>Most changes in customer behavior don&apos;t mean a customer is about to leave. Some do.</p>
            <p>
              ChurnSignal looks at changes in product usage and billing together, rather than treating every drop, spike
              or warning as churn risk.
            </p>
            <p className="text-primary">
              The goal isn&apos;t another warning for your team to investigate. It&apos;s knowing which accounts
              actually warrant a closer look.
            </p>
          </div>
        </LandingReveal>

        <div className="landing-flow-grid grid md:grid-cols-3 gap-6 mb-10">
          {questions.map((item, index) => (
            <LandingReveal
              key={item.step}
              delayClass={index === 0 ? 'landing-delay-1' : index === 1 ? 'landing-delay-2' : 'landing-delay-3'}
            >
              <div className="landing-flow-step landing-card p-6 md:mr-6 h-full">
                <span className="text-sm font-bold tracking-widest mb-3 block" style={{ color: item.color }}>
                  {item.step}
                </span>
                <h3 className="text-xl font-bold text-primary font-secondary mb-3">{item.title}</h3>
                <p className="text-secondary leading-relaxed">{item.description}</p>
              </div>
            </LandingReveal>
          ))}
        </div>

        <LandingReveal delayClass="landing-delay-1">
          <div className="landing-screenshot-frame rounded-2xl overflow-hidden bg-dark-gray-b">
            <img
              src="/images/actions1.png"
              alt="ChurnSignal MVP — risk score, key factors, and recommended actions for an at-risk customer"
              className="w-full object-contain"
            />
            <div className="px-6 py-4 border-t border-light bg-surface-subtle">
              <p className="text-sm text-secondary text-center">
                Early product view — risk surfaced, reason explained, action recommended for a single account.
              </p>
            </div>
          </div>
        </LandingReveal>
      </div>
    </section>
  );
}
